import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../Services/auth.service';
import { NotificationService } from '../../../../Services/notification.service';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-ca-account',
  imports: [FormsModule],
  templateUrl: './ca-account.component.html',
  styleUrl: './ca-account.component.css'
})
export class CaAccountComponent implements OnInit {

  caData: any;
  caId: any;
  email: string = '';
  password: string = '';
  master_password: string = '';

  constructor(private authService: AuthService, private notification: NotificationService, private staffService: UserStaffService) { }

  ngOnInit(): void {
    this.getCaData();
  }

  getCaData() {
    this.staffService.getUserStaffById(this.authService.getUserId()).subscribe((res: any) => {
      this.caData = res.data;
      this.email = this.caData?.email;

    })
  }

  updatePassword() {

    const formData = new FormData();

    formData.append('email', this.email);
    formData.append('password', this.password);
    formData.append('master_password', this.master_password);

    // 👇 IMPORTANT
    formData.append('_method', 'PUT');

    this.staffService.updateUserStaff(this.caData.id, formData)
      .subscribe((res: any) => {
        this.notification.showSuccess(
          "Password updated successfully",
          "success"
        );
      });
  }

}
